<template>
  <el-card :body-style="{ height: '100%' }" class="h-full">
    <div class="h-full flex flex-col">
      <div class="overflow-y-auto overflow-x-hidden flex-auto">
        <div class="flex items-center h-32px" v-if="['create', 'update', 'approve'].includes(mode)">
          <p class="pl-10px border-l-3px text-18px border-color-primary">
            {{ titleType }}{{ $t('基础信息') }}
          </p>
        </div>
        <el-page-header
          v-else
          :content="`${titleType}${$t('基础信息')}`"
          @back="goBack"
        ></el-page-header>
        <el-form
          ref="form"
          class="my-20px contractor-person-form"
          :model="form"
          :rules="rules"
          label-width="150px"
          :disabled="!canEdit"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item prop="avatar">
                <div slot="label" class="leading-1">
                  <span class="leading-23px">{{ $t('人脸头像') }}</span>
                  <div class="text-red-500 cursor-pointer leading-23px" @click.stop="damendExample">
                    ({{ $t('查看上传要求') }})
                  </div>
                </div>
                <img-upload
                  v-model="form.avatar"
                  :authLevel="2"
                  @delete="form.avatar = ''"
                  :isDisabledUploadComponent="!canEdit"
                  :isShowDeleteButton="canEdit"
                  @change="$refs.form.clearValidate('avatar')"
                  :maxSize="0.2"
                  :accept="['jpg']"
                  ref="avatarUpload"
                ></img-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('身份证正面')}`" prop="idCardFrontFileId">
                <img-upload
                  v-model="form.idCardFrontFileId"
                  :isDisabledUploadComponent="!canEdit"
                  :isShowDeleteButton="canEdit"
                  @delete="form.idCardFrontFileId = null"
                  @upload-success="getImageContent"
                  @change="$refs.form.clearValidate('idCardFrontFileId')"
                  ref="idCardFrontUpload"
                ></img-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('身份证反面')}`" prop="idCardReverseFileId">
                <img-upload
                  v-model="form.idCardReverseFileId"
                  :isDisabledUploadComponent="!canEdit"
                  :isShowDeleteButton="canEdit"
                  @delete="form.idCardReverseFileId = null"
                  @change="$refs.form.clearValidate('idCardReverseFileId')"
                  ref="idCardReverseUpload"
                ></img-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('姓名')}`" prop="name">
                <el-input
                  size="small"
                  v-model="form.name"
                  maxlength="50"
                  show-word-limit
                  :placeholder="`${$t('请输入')}`"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('账户')}`" prop="userName">
                <el-input
                  size="small"
                  v-model="form.userName"
                  maxlength="50"
                  show-word-limit
                  :placeholder="`${$t('请输入')}`"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('性别')}`" prop="gender">
                <el-radio-group v-model="form.gender">
                  <el-radio label="1">{{ $t('男') }}</el-radio>
                  <el-radio label="0">{{ $t('女') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('部门')}/${$t('单位')}`">
                <el-input v-model="contractorDetail.orgName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('排序')}`" prop="sortNum">
                <el-input-number
                  :step="1"
                  :max="999"
                  step-strictly
                  v-model="form.sortNum"
                  :placeholder="`${$t('请输入')}`"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('联系电话')}`" prop="phoneNumber">
                <el-input
                  size="small"
                  v-model="form.phoneNumber"
                  maxlength="50"
                  show-word-limit
                  :placeholder="`${$t('请输入')}`"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="flex items-center h-32px mb-10px">
            <p class="pl-10px border-l-3px text-18px border-color-primary">
              {{ titleType }}{{ $t('补充信息') }}
            </p>
          </div>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('关联项目')}`" prop="projectId">
                <el-select
                  size="small"
                  class="w-full"
                  filterable
                  :placeholder="`${$t('请选择')}`"
                  clearable
                  v-model="form.projectId"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.projectName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('身份证号码')}`" prop="idCard">
                <el-input
                  v-model="form.idCard"
                  :placeholder="`${$t('请输入')}`"
                  @blur="idCardChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('入厂时间')}`" prop="factoryInDate">
                <el-date-picker
                  size="small"
                  v-model="form.factoryInDate"
                  class="!w-full"
                  type="date"
                  :placeholder="`${$t('请选择')}`"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('出生日期')}`" prop="birthday">
                <el-date-picker
                  size="small"
                  v-model="form.birthday"
                  class="!w-full"
                  type="date"
                  :placeholder="`${$t('请选择')}`"
                  value-format="yyyy-MM-dd"
                  @change="birthdayChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('年龄')}`" prop="age">
                <el-input-number
                  v-model="form.age"
                  :min="1"
                  :step="1"
                  class="w-full form-input-number"
                  :controls="false"
                  step-strictly
                  :max="999"
                  :placeholder="`${$t('请输入')}`"
                  v-if="canEdit"
                ></el-input-number>
                <el-input v-else v-model="form.age" :placeholder="`${$t('请输入')}`"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('婚姻状况')}`" prop="maritalStatusId">
                <el-select
                  class="w-full"
                  v-model="form.maritalStatusId"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in maritalStatusList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('邮箱')}`" prop="email">
                <el-input
                  v-model="form.email"
                  :placeholder="`${$t('请输入')}`"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('文化程度')}`" prop="education">
                <el-select
                  class="w-full"
                  v-model="form.education"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in educationList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('民族')}`" prop="ethnic">
                <el-input
                  size="small"
                  v-model="form.ethnic"
                  maxlength="50"
                  :placeholder="`${$t('请输入')}`"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('工种')}`" prop="jobCategory">
                <el-select
                  class="w-full"
                  v-model="form.jobCategory"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in workTypeList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('人员分类')}`" prop="employeeType">
                <el-select
                  class="w-full"
                  v-model="form.employeeType"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in personnelCategoryList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('班组')}`" prop="teamId">
                <el-select
                  class="w-full"
                  v-model="form.teamId"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in teamList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('是否厂内人员')}`" prop="isFactoryIn">
                <el-radio-group v-model="form.isFactoryIn">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('职务')}/${$t('工种')}`" prop="postJobCategory">
                <el-select
                  class="w-full"
                  v-model="form.postJobCategory"
                  filterable
                  clearable
                  :placeholder="`${$t('请选择')}`"
                >
                  <el-option
                    v-for="item in dutieJobList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('是否特种作业')}`" prop="isSpecialJob">
                <el-radio-group v-model="form.isSpecialJob">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
              <el-form-item :label="`${$t('是否临时用工')}`" prop="isTempWork">
                <el-radio-group v-model="form.isTempWork">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="['read'].includes(mode) && form.approvalStatus === 9">
            <div class="flex items-center h-32px mb-10px">
              <p class="pl-10px border-l-3px text-18px border-color-primary">
                {{ $t('在厂信息') }}
              </p>
            </div>
            <el-tabs class="tab-bar" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="`${$t('考试记录')}`" name="examRecord">
                <ExamRecord :userId="form.userId" class="h-400px" ref="examRecord" />
              </el-tab-pane>
              <el-tab-pane :label="`${$t('培训记录')}`" name="trainingRecord">
                <TrainingRecord :userId="form.userId" class="h-400px" ref="trainingRecord" />
              </el-tab-pane>
              <el-tab-pane :label="`${$t('违章记录')}`" name="violationRecord">
                <ViolationRecord
                  :userId="form.userId"
                  :unitId="form.departmentId"
                  class="h-400px"
                  ref="violationRecord"
                />
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-form>
      </div>
      <div
        class="text-center pt-20px border-t-1px border-color-default"
        v-if="['create', 'update', 'approve'].includes(mode)"
      >
        <el-button
          type="primary"
          size="small"
          @click="save('save')"
          v-if="canEdit && !form.isBlackList"
          :loading="loading"
          >{{ $t('保存') }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="save('submit')"
          v-if="
            (canEdit || mode === 'approve') &&
              !form.isBlackList &&
              ([0, 3].includes(form.approvalStatus) ||
                ([2].includes(form.approvalStatus) && form.taskId))
          "
          :loading="loading"
          >{{ $t('提交') }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="approvalDialog = true"
          v-if="mode === 'approve' && !form.isBlackList && [1].includes(form.approvalStatus)"
          >{{ $t('审批') }}</el-button
        >
        <el-button size="small" @click="goBack">{{ $t('取消') }}</el-button>
      </div>
    </div>
    <FaceAvatarStandard :visible.sync="dialogExampleShow" />
    <ApprovalDialog
      :visible.sync="approvalDialog"
      :loading="approvalLoading"
      @submit="submitApproval"
    />
  </el-card>
</template>

<script>
import {
  ContractorPersonnelApi,
  PeriodContractorPersonnelApi,
  PeriodContractorApi,
  ContractorProjectApi,
} from '@wiz-api/contractor-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { TeamApi } from '@wiz-api/team-management'
import { find, isNil } from 'lodash'
import dayjs from 'dayjs'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'

const ImgUpload = () => {
  return import('@/components/safety/ImgUpload/ImgUpload')
}
const FaceAvatarStandard = () => {
  return import('@/components/safety/WizSafetyPage/FaceAvatarStandard')
}
const ExamRecord = () => {
  return import('@/components/safety/WizSafetyPage/PersonExamRecord')
}
const TrainingRecord = () => {
  return import('@/components/safety/WizSafetyPage/PersonTrainingRecord')
}
const ViolationRecord = () => {
  return import('@/components/safety/WizSafetyPage/PersonViolationRecord')
}
const ApprovalDialog = () => {
  return import('@/components/safety/ApprovalFlow/ApprovalDialog')
}
const contractorPersonnelApi = new ContractorPersonnelApi()
const periodContractorPersonnelApi = new PeriodContractorPersonnelApi()
const periodContractorApi = new PeriodContractorApi()
const dataCategoryApi = new DataCategoryApi()
const teamApi = new TeamApi()
const contractorProjectApi = new ContractorProjectApi()
// 姓名校验
const validateName = (rule, value, callback) => {
  // 中文
  const reg = /^[a-zA-Z]+$|^[\u4E00-\u9FA5]+$/
  if (!value) {
    callback(new Error('请输入姓名'))
  } else if (!reg.test(value)) {
    callback(new Error('姓名只能全中文或者全英文'))
  } else {
    callback()
  }
}
const validateAccount = (rule, value, callback) => {
  const orderRule = /^[a-zA-Z0-9]+$/
  if (!value) {
    callback(new Error('请输入账号'))
  } else if (!orderRule.test(value)) {
    callback(new Error('请输入英文或数字'))
  } else {
    callback()
  }
}
const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('手机号不能为空'))
    return
  }
  const reg = /^1[3-9]{1}[0-9]{9}$/
  if (!reg.test(value)) {
    callback(new Error('请填写正确的手机号'))
    return
  }
  callback()
}
// 身份证验证
const validateCard = (rule, value, callback) => {
  const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  if (!value || reg.test(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的身份证号码'))
  }
}
export default {
  components: {
    ImgUpload,
    FaceAvatarStandard,
    ExamRecord,
    TrainingRecord,
    ViolationRecord,
    ApprovalDialog,
  },
  props: {
    formMode: {
      type: String,
      default: 'read',
    },
    formId: {
      type: String,
      default: '',
    },
    formContractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogExampleShow: false,
      form: {
        avatar: '',
        idCardFrontFileId: null,
        idCardReverseFileId: null,
        isTempWork: false,
        isSpecialJob: false,
        isFactoryIn: true,
        gender: '1',
        sortNum: 0,
        approvalStatus: 0,
      },
      rules: {
        avatar: [{ required: true, message: '请上传人脸头像', trigger: ['blur', 'change'] }],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        name: [{ required: true, validator: validateName, trigger: ['blur', 'change'] }],
        userName: [{ required: true, validator: validateAccount, trigger: ['blur', 'change'] }],
        gender: [{ required: true, message: '请选择性别', trigger: ['blur', 'change'] }],
        sortNum: [{ required: true, message: '请输入排序', trigger: ['blur', 'change'] }],
        jobCategory: [{ required: true, message: '请选择工种', trigger: ['blur', 'change'] }],
        employeeType: [{ required: true, message: '请选择人员分类', trigger: ['blur', 'change'] }],
        isFactoryIn: [
          { required: true, message: '请选择是否厂内人员', trigger: ['blur', 'change'] },
        ],
        isTempWork: [
          { required: true, message: '请选择是否临时用工', trigger: ['blur', 'change'] },
        ],
        idCard: [{ required: false, validator: validateCard, trigger: ['blur', 'change'] }],
      },
      maritalStatusList: [],
      educationList: [],
      workTypeList: [],
      personnelCategoryList: [],
      teamList: [],
      dutieJobList: [],
      activeName: 'examRecord',
      loading: false,
      approvalDialog: false,
      approvalLoading: false,
      contractorDetail: {},
      projectList: [],
    }
  },
  computed: {
    mode() {
      if (this.$route.name === 'shortTermContractorPerson') {
        return this.$route.query.mode
      }
      return this.formMode
    },
    id() {
      if (this.$route.name === 'shortTermContractorPerson') {
        return this.$route.query.id
      }
      return this.formId
    },
    contractorId() {
      if (this.$route.name === 'shortTermContractorPerson') {
        return this.$route.query.contractorId
      }
      return this.formContractorId
    },
    canEdit() {
      return (
        ['create', 'update'].includes(this.mode) ||
        (['approve'].includes(this.mode) && this.form.approvalStatus === 2)
      )
    },
    titleType() {
      const modeObj = {
        create: '新增',
        update: '编辑',
        read: '查看',
        approve: '查看',
      }
      return `${this.$t(`${modeObj[this.mode]}`)}`
    },
  },
  methods: {
    goBack() {
      if (this.$route.name === 'shortTermContractorPerson') {
        this.$router.go(-1)
      } else {
        this.$emit('back')
      }
    },
    // 头像要求示范
    damendExample() {
      this.dialogExampleShow = true
    },
    // 拿到图片内容
    async getImageContent(content) {
      const [err, res] = await contractorPersonnelApi.getContractorPersonnelIDCardFileContent({
        files: [content],
      })
      if (!err) {
        const { age, idCard, name, national, sex } = res
        if (res.idCard) {
          this.form.age = age
          this.form.idCard = idCard
          this.form.name = name
          this.form.ethnic = national
          // 性别字典对应
          if (sex) {
            this.form.gender = sex === '男' ? '1' : '0'
          } else {
            this.form.gender = null
          }
        }
      }
    },
    birthdayChange(val) {
      const age = this.getAge(val)
      this.form.age = age
    },
    idCardChange() {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      const idCard = this.form.idCard
      if (reg.test(idCard)) {
        const birth = `${idCard.substring(6, 10)}-${idCard.substring(10, 12)}-${idCard.substring(
          12,
          14
        )}`
        this.form.birthday = birth
        this.birthdayChange(birth)
      }
    },
    getAge(val) {
      const currentYear = new Date().getFullYear() // 当前的年份
      const calculationYear = new Date(val).getFullYear() // 计算的年份
      const wholeTime = currentYear + val.substring(4) // 周岁时间
      const calculationAge = currentYear - calculationYear // 按照年份计算的年龄
      // 判断是否过了生日
      if (new Date().getTime() > new Date(wholeTime).getTime()) {
        return calculationAge
      }
      return calculationAge - 1
    },
    // 获取数据字典数据 -工种类型 -婚姻状况 -文化程度
    async getCategoryList() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: [
          'AccountWorkType',
          'AccountMaritalStatus',
          'AccountEduLevel',
          'AccountEmployeeType',
          'DutieJob',
        ],
        includeDetails: true,
      })
      if (!err) {
        this.workTypeList = find(res, ['code', 'AccountWorkType'])?.dataItems
        this.maritalStatusList = find(res, ['code', 'AccountMaritalStatus'])?.dataItems
        this.educationList = find(res, ['code', 'AccountEduLevel'])?.dataItems
        this.personnelCategoryList = find(res, ['code', 'AccountEmployeeType'])?.dataItems
        this.dutieJobList = find(res, ['code', 'DutieJob'])?.dataItems
      }
    },
    // 获取项目清单列表
    async getSafetyProjectList() {
      const data = {
        contractorId: this.form.contractorId,
        maxResultCount: 1000, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [error, result] = await contractorProjectApi.relatedProjectPageList(data)
      if (!error) {
        this.projectList = result.items || []
      }
    },
    // 获取班组
    async getTeamList() {
      const [err, res] = await teamApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        isEnabledPermissions: false,
      })
      if (!err) {
        this.teamList = res.items
      }
    },
    handleClick(tab) {
      this.$refs[tab.name].searchList()
    },
    save(type) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let apiRes = []
          let msgType = ''
          this.form.birthday = this.form.birthday
            ? dayjs(this.form.birthday).format('YYYY-MM-DD HH:mm:ss')
            : null
          this.form.factoryInDate = this.form.factoryInDate
            ? dayjs(this.form.factoryInDate).format('YYYY-MM-DD HH:mm:ss')
            : null
          if (type === 'submit') {
            msgType = '提交'
            if (this.form.approvalStatus === 2) {
              await periodContractorPersonnelApi.update(this.form.id, {
                body: this.form,
              })
              apiRes = await periodContractorPersonnelApi.approve({
                body: {
                  id: this.form.id,
                  isPass: true,
                  approve: '',
                  taskId: this.form.taskId,
                },
              })
            } else {
              apiRes = await periodContractorPersonnelApi.submit({
                body: this.form,
              })
            }
          } else if (this.mode === 'create') {
            msgType = '新增'
            apiRes = await periodContractorPersonnelApi.create({
              body: this.form,
            })
          } else {
            msgType = '编辑'
            apiRes = await periodContractorPersonnelApi.update(this.form.id, {
              body: this.form,
            })
          }
          this.loading = false
          if (!apiRes[0]) {
            this.$message.success(`${msgType}成功!`)
            this.goBack()
          }
        }
      })
    },
    async getContractorDetail() {
      const [err, res] = await periodContractorApi.getInfo(this.form.contractorId)
      if (!err) {
        this.contractorDetail = res
        this.form.departmentId = res.orgId
      }
    },
    async getDetail() {
      const [err, res] = await periodContractorPersonnelApi.getInfo(this.id)
      if (!err) {
        this.form = res
        if (res.avatar) {
          this.$refs.avatarUpload?.getImgContent([res.avatar])
        }
        if (res.idCardFrontFileId) {
          this.$refs.idCardFrontUpload?.getImgContent([res.idCardFrontFileId])
        }
        if (res.idCardReverseFileId) {
          this.$refs.idCardReverseUpload?.getImgContent([res.idCardReverseFileId])
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    },
    async submitApproval(data) {
      this.approvalLoading = true
      const [err] = await periodContractorPersonnelApi.approve({
        body: {
          id: this.form.id,
          isPass: data.isPass,
          approve: data.opinion,
          taskId: this.form.taskId,
        },
      })
      this.approvalLoading = false
      if (!err) {
        this.approvalDialog = false
        this.$message.success('审批成功！')
        this.goBack()
      }
    },
  },
  async mounted() {
    await this.getCategoryList()
    await this.getTeamList()
    if (this.mode === 'create') {
      this.form.contractorId = this.contractorId
    } else {
      await this.getDetail()
    }
    if (!this.canEdit) {
      clearPlaceholder('.contractor-person-form')
    }
    await this.getContractorDetail()
    await this.getSafetyProjectList()
  },
}
</script>

<style lang="scss" scoped>
.form-input-number {
  ::v-deep .el-input__inner {
    text-align: left;
  }
}
</style>
